/*
 *
 * PayByLinkFirstActivationPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 27-Mar-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import { flowPopupMapType } from 'Utility/flowPopupMap'
import './PayByLinkFirstActivationPopup.scss'

const PayByLinkFirstActivationPopup = (props) => (
  <Toggle>
    <div className='pblFirstPopup'>
      <MerchantModal
        title={formattedMessage.firstActivationPopupTitle}
        description={formattedMessage.firstActivationPopupCopy}
        ariaModalTitle={formattedMessage.firstActivationPopupTitle}
        ariaModalDescription={formattedMessage.firstActivationPopupCopy}
        onClose={() => props.actions.doHidePopup()}
        primaryAction={() => {
          props.actions.doShowPopup(flowPopupMapType.PAY_BY_LINK_TUTORIAL)
        }}
        primaryButtonLabel={formattedMessage.firstActivationPopupButtonLabel}
      >
        <div className='pblFirstPopupList'>
          <p>{formattedMessage.firstActivationPopupCopyFirstPoint}</p>
          <p>{formattedMessage.firstActivationPopupCopySecondPoint}</p>
          <p>{formattedMessage.firstActivationPopupCopyThirdPoint}</p>
        </div>
      </MerchantModal>
    </div>
  </Toggle>
)

PayByLinkFirstActivationPopup.propTypes = {
  actions: PropTypes.object.isRequired
}

PayByLinkFirstActivationPopup.defaultProps = {
  actions: {}
}

export default PayByLinkFirstActivationPopup
